<template>
    <div class="prod-item-page" v-if="curProd" :class="{'slimMode': isSlimMode()}">
        <div class="page-container" id="page-container">
            <div class="prod-item-header-container" :class="{'has-data-container': showPrice() || curProd.productDescription}">
                <div class="header">
                    <CircleButton class="back" :big="true" :outline="true" :icon="arrow_back_white" @circleBtnClick="closeProductItem()"></CircleButton>
                    <h3 v-text="getProductLanguage(curProd, 'productName')"></h3>
                </div>
                <div class="image-container">
                    <img v-if="curProd.productImages && curProd.productImages.large != null" :src="getImagesURL(curProd, 'productImages', 'large')" alt="">
                    <img v-else :src="noImageSrc">
                </div>
                <div class="data-container" v-if="showPrice()">
                    <div class="price-container">
                        <span class="price"
                            v-text="formatMoney(totalPrice)">
                        </span>
                        <QuantityControl :quantity="curProd.quantity" @circleBtnRemove="decreaseQtty(editKey)" @circleBtnAdd="increaseQtty(editKey)"></QuantityControl>
                    </div>
                </div>
                <div class="details-container" v-if="curProd.productDescription">
                    <p v-text="getString('descricao') + (cutText(getProductLanguage(curProd, 'productDescription')))" @click="showText = !showText"></p>
                </div>
            </div>

            <template v-if="isSimpleProduct()">
                <div class="observations-container" v-for="(obc, key) in curProd.observationsChoice" :key="key">
                    <span class="grupo-op-name">
                        <span v-text="getProductLanguage(obc, 'obsGroupName')"></span>
                        <span v-text="`${curProd.observations.length || 0} / ${curProd.observationsChoice[key].maxQuantity || (obc.observations || []).length}`"></span>
                    </span>
                    <div class="min-observations-message" v-if="obc.minQuantity > 0" :class="{'red-text': curProd.observations.length < obc.minQuantity}">{{ getMessageObservationsMinQuantity(obc.minQuantity) }}</div>
                    <div class="obs-item-container">
                        <div class="item-obs" v-for="(obs, key2) in removeBlockedProdsObs(obc.observations)" :key="key2">
                            <div class="container-input" v-if="(curProd.observationsChoice[key].maxQuantity !== 1)">
                                <input class="styled-input" :id="key + obs.obsCode" type="checkbox" :value="obs" v-model="curProd.observations" @change="validateObs(obs, $event)">
                                <span class="checkmark"></span>
                            </div>
                            <div class="container-input" v-else>
                                <input class="styled-input" :id="key + obs.obsCode" :name="obc.obsGroupName" type="radio" :value="obs" v-model="curProd.observations" @change="validateObs(obs, $event)">
                                <span class="checkmark radio"></span>
                            </div>
                            <label style="display: block; margin: auto 0;" :for="key + obs.obsCode" >
                                <span v-text="getProductLanguage(obs, 'obsName')"></span>
                                <span v-if="obs.price" v-text="` + ${formatMoney(obs.price)}`"></span>
                            </label>
                        </div>
                        <!-- Este bloco voltará a ser utilizado caso as observações passem a ter quantidades editáveis novamente -->
                        <!-- <div class="item-obs" :class="{'quantity-control': obs.quantity !== undefined}" v-for="(obs, key2) in obc.observations" :key="key2">
                            <div v-if="obs.quantity === undefined" class="container-input">
                                <input class="styled-input" :id="key + obs.obsCode" type="checkbox" :value="obs" v-model="curProd.observations" @change="validateObs(obs, $event)">
                                <span class="checkmark"></span>
                            </div>
                            <QuantityControl v-else
                                :quantity="obc.observations[key2].quantity || 0"
                                @circleBtnRemove="decreaseObservationQtty(key, key2)"
                                @circleBtnAdd="increaseObservationQtty(key, key2)">
                            </QuantityControl>
                            <label style="display: block; margin: auto 0;" :for="key + obs.obsCode" >
                                <span v-text="obs.obsName"></span>
                                <span v-if="obs.price" v-text="` + ${formatMoney(obs.price)}`"></span>
                            </label>
                        </div> -->
                    </div>
                </div>
            </template>

            <!-- Observação Digitada -->
            <div class="observations-container" v-if="exibeObsDigitada">
                <span class="grupo-op-name">
                    <span>{{ getString('observacao_livre') }}</span>
                </span>
                <!-- <textarea v-model="typedObs" class="typed-obs-text" id="typed-obs" rows="5" maxlength="25" @focus="show"></textarea> -->
                <div id="typed-obs" ref="typedObsDiv" class="div-input-android" @click="editObs"></div>
            </div>
            <div id="keyboard-filler" v-if="editingObs"></div>

            <div class="row">
                <transition-group name="fade">
                    <WizardStepGom
                        v-for="(combo, key) in curProd.productGroups"
                        :key="'wizard-step-key-' + key"
                        :id="'curProd' + '-' + key"
                        :combo="combo"
                        :zindex="itensLeft - key"
                        :chosen="curProd.productComboRaw && curProd.productComboRaw[key]"
                        :fatherProdCode="curProd.productCode"
                        :fatherPrint="curProd.productPrint"
                        :depth="key"
                        :curComboKey="curComboKey"
                        :mutexData="mutexData"
                        :isEditing="!!editProduct"
                        :alternativeLayoutCounter="alternativeLayoutCounter"
                        v-show="!combo.listed && (wizardStepInEvidence === key || combo.isVisible)"
                        @comboOption="comboOption"
                        @updateComboPrice="updateComboPrice"
                        @clearSelectedMutex="clearSelectedMutex"
                        @updateNextButton="updateNextButton"
                        @openSelectMutexModal="openSelectMutexModal"
                        :blockProds="blockProds">
                    </WizardStepGom>
                </transition-group>
            </div>
        </div>
        <Transition name="fade">
            <SelectMutexModalGom v-if="showSelectMutexModal"
                :groupsData="groupsData"
                :calledOnMounted="calledOnMounted"
                :oldProductGroup="oldProductGroup"
                @closeSelectMutexModal="closeSelectMutexModal"
                @pickMutexGroup="pickMutexGroup">
            </SelectMutexModalGom>
        </Transition>

        <div class="prod-item-footer" v-if="loaded">
            <DefaultButton
                v-if="showCancelButton()"
                :text="getString('cancelar')"
                outlined="true"
                @defaultBtnClick="cancel()">
            </DefaultButton>
            <DefaultButton v-else :text="getString('voltar')" @defaultBtnClick="previousWizardStep()"></DefaultButton>
            <DefaultButton
                v-if="showAddToCartButton()"
                :text="this.editProduct ? getString('confirmar_edicao') : getString('adicionar_ao_carrinho')"
                @defaultBtnClick="addToCart()"
                :class="{'disabled': wait}"
                :disabled="minObs">
            </DefaultButton>
            <DefaultButton
                v-else
                :text="getString('proximo')"
                :disabled="!enabledNextButton"
                @defaultBtnClick="nextWizardStep()"
                :class="{'shake-button': enabledNextButton && !preventShaking}">
            </DefaultButton>
        </div>

        <div class="keyboard-overlay" v-if="editingObs" @click="closeKeyboard"></div>
        <AndroidKeyboard id="android-keyboard" v-if="editingObs"
            :inputElement="inputElement"
            :layout="layout">
        </AndroidKeyboard>
        <!-- <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" /> -->
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import ProductController from '@/assets/controllers/ProductController'
import Header from '@/components/Header'
import DefaultButton from '@/components/DefaultButton'
import QuantityControl from '@/components/QuantityControl'
import WizardStepGom from '@/components/WizardStepGom'
import SelectMutexModalGom from '@/components/SelectMutexModalGom'
import eventModule from '@/assets/libs/eventModule'
import LocaleController from '@/assets/controllers/LocaleController'
import CircleButton from '@/components/CircleButton'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import PromotionalCampaignsController from '@/assets/controllers/PromotionalCampaignsController'
import ClarityController from '../assets/controllers/ClarityController'

export default {
    name: 'ProductItemGom',
    components: {
        Header,
        DefaultButton,
        QuantityControl,
        WizardStepGom,
        SelectMutexModalGom,
        AndroidKeyboard,
        CircleButton
    },
    props: ['selectedProduct', 'editProduct', 'editKey'],
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.TEXT,
            editingObs: false,
            input: null,
            noImageSrc: null,
            curProd: null,
            treatedComboItems: [],
            hasToPickOptions: false,
            itensLeft: 0,
            curComboKey: 0,
            mutexData: null,
            mutexDataBkp: null,
            blockProds: [],
            useAlternativeLayout: true, // Util.getLocalConfigs('useAlternativeLayout'),
            alternativeLayoutCounter: 1,
            wizardStepInEvidence: 0,
            enabledNextButton: false,
            calledOnMounted: false,
            preventShaking: false,
            goingForward: true,
            exibeObsDigitada: false,
            typedObs: '',
            showSelectMutexModal: false,
            groupsData: [],
            totalPrice: 0,
            wait: false,
            oldProductGroup: null,
            showText: false,
            loaded: false,
            junk: require('../../static/icons/junk-icon.png'),
            arrow_back_white: require('../../static/icons/arrow_back_white.svg'),
            enableJumpGroup: Util.getLocalConfigs('avancagrupomax'),
            minObs: false
        }
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        this.curProd = this.selectedProduct || this.editProduct
        this.blockProds = Util.getLocalVar('blockProds')
        this.exibeObsDigitada = Util.getLocalConfigs('permiteObsDigitada') && this.isSimpleProduct()

        if (this.exibeObsDigitada) {
            this.typedObs = this.curProd.typedObs ? this.curProd.typedObs : ''
        }

        this.addProductGroupCodeOnItem()

        this.mutexData = this.curProd.mutexData ? this.curProd.mutexData : this.buildMutexData()
        this.mutexDataBkp = Util.deepCopy(this.mutexData)
        this.curProd.productGroups.forEach(p => delete p.listed)
        this.curProd.productComboBkp = this.curProd.productCombo ? Util.deepCopy(this.curProd.productCombo) : []
        this.curProd.observationsBkp = this.curProd.observations ? Util.deepCopy(this.curProd.observations) : []
        this.curProd.productGroupsBkp = this.curProd.productGroups ? Util.deepCopy(this.curProd.productGroups) : []
        this.curProd.productComboRawBkp = this.curProd.productComboRaw ? Util.deepCopy(this.curProd.productComboRaw) : []

        if (this.curProd && this.curProd.productCode) {
            this.curProd.quantity = this.curProd.quantity || 1
            this.curProd.totalItemPrice = this.editProduct && this.curProd ? parseFloat(this.curProd.totalItemPrice) : parseFloat(this.curProd.price)

            this.curProd.observations = this.editProduct && this.curProd ? this.curProd.observations : []
            this.curProd.observationsChoice && this.curProd.observationsChoice.forEach(obc => {
                (obc.observations || []).forEach(obs => {
                    obs.obsGroupCode = obc.obsGroupCode
                })
            })

            // Se o usuário entrou nesta tela para editar um produto, este bloco atualiza as quantidades no
            // array observationsChoice de acordo com as quantidades no array observations, caso necessário
            if (this.curProd.observations.length > 0) {
                this.curProd.observations.forEach(obs => {
                    if (obs.quantity !== undefined && obs.quantity > 0) {
                        for (let i = 0; i < this.curProd.observationsChoice.length; i++) {
                            let obsIndex = this.curProd.observationsChoice[i].observations.findIndex(element => {
                                return element.obsCode === obs.obsCode &&
                                    element.obsGroupCode === obs.obsGroupCode &&
                                    element.obsName === obs.obsName &&
                                    element.price === obs.price
                            })
                            if (obsIndex !== -1) {
                                this.curProd.observationsChoice[i].observations[obsIndex].quantity = obs.quantity
                            }
                        }
                    }
                })
            }

            this.curProd.productCombo = (this.editProduct && this.curProd) ? this.curProd.productCombo : []
        } else {
            this.cancel()
        }

        if (!this.isSimpleProduct()) {
            this.updateNextButton()
            this.handleFirstGroupMutexCase()
        }
        this.minObs = this.editProduct ? false : (!(this.curProd.productGroups && this.curProd.productGroups.length > 0) && !this.checkMinObs())
        if (this.curProd.productGroups && this.curProd.productGroups.length > 0) {
            CartController.setProductSequence(this.curProd, null, 0, 0)
        }
        this.updateComboPrice()
        eventModule.$emit('updateButtonCart', false)
        setTimeout(() => {
            this.loaded = true
        }, 500)
        ClarityController.event('navegou_para_' + 'productitem')
        ClarityController.setTag('url_atual', '/productitem')
    },
    methods: {
        addProductGroupCodeOnItem: function () {
            this.curProd.productGroups.forEach(prod => {
                if (prod.productGroupCode) {
                    prod.productGroupItems.forEach(gi => {
                        gi.productGroupCode = prod.productGroupCode
                        gi.subItemProductGroups.forEach(sgi => {
                            if (sgi.subProductGroupCode) {
                                sgi.subProductGroupItems.forEach(si => {
                                    si.subProductGroupCode = sgi.subProductGroupCode
                                })
                            }
                        })
                    })
                }
            })
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        showPrice: function () {
            let showMinPriceDifference = Util.getLocalConfigs('showMinPriceDifference')
            return (this.curProd.productPrint === 'S' && !showMinPriceDifference) || this.curProd.productGroups.length === 0
        },
        isSlimMode: function () {
            return Util.isSlimMode()
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target

                if (!this.visible) {
                    this.visible = true
                }

                let container = document.getElementById('page-container')
                setTimeout(() => {
                    container.scrollTo(0, container.scrollHeight)
                }, 100)
            }
        },
        hide: function () {
            this.visible = false
        },
        clearSelectedMutex: function (productGroupMutex) {
            let newMutexData = Util.deepCopy(this.mutexData)
            newMutexData[productGroupMutex].selectedMutexCode = null
            this.mutexData = newMutexData
        },
        buildMutexData: function () {
            let mutexData = {}

            this.curProd.productGroups.forEach((group, index) => {
                if (group.productGroupMutex && group.productGroupMutex !== null) {
                    if (!mutexData[group.productGroupMutex]) {
                        mutexData[group.productGroupMutex] = {
                            groups: [],
                            selectedMutexCode: null,
                            alternativeLayoutPickedGroupIndex: null
                        }
                    }
                    mutexData[group.productGroupMutex].groups.push({
                        productGroupName: group.productGroupName,
                        productGroupCode: group.productGroupCode,
                        productGroupIndex: index
                    })
                }
            })

            let mutexKeys = Object.keys(mutexData)
            mutexKeys.forEach(key => {
                // Se o grupo mutex contiver apenas um grupo de produtos, ele não precisa ser tratado como mutex
                if (mutexData[key].groups.length < 2) {
                    delete mutexData[key]
                }
            })

            return mutexData
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        validateObs: function (obs, clickEvent) {
            let obsGroup = this.curProd.observationsChoice.find(element => element.obsGroupCode === obs.obsGroupCode)
            let maxObservations = obsGroup.maxQuantity || 0
            let minObservations = obsGroup.minQuantity || 0
            let groupSelectedObs = []

            if (this.curProd.observations && this.curProd.observations.length) {
                groupSelectedObs = this.curProd.observations.filter(element => element.obsGroupCode === obs.obsGroupCode)
            }

            let groupObsNumber = (groupSelectedObs && groupSelectedObs.length) || 0
            let checkObsMax = ((maxObservations != null && maxObservations !== 0) && groupObsNumber > maxObservations && clickEvent.srcElement.checked)
            let checkObsMin = (minObservations === 0) || ((minObservations != null && minObservations !== 0) && groupObsNumber >= minObservations)
            if (checkObsMax) {
                this.curProd.observations.pop()
                clickEvent.srcElement.checked = false
            }
            this.minObs = !checkObsMin
            this.updateComboPrice()
            if (clickEvent.srcElement.checked) {
                ClarityController.event('usuario_selecionou_observacao')
                ClarityController.setTag('observacao_selecionada', obs.obsName)
            } else {
                ClarityController.event('usuario_removeu_observacao')
                ClarityController.setTag('observacao_deselecionada', obs.obsName)
            }
            // this.$forceUpdate()
        },
        priceUpdate: function () {
            ProductController.priceUpdate(this.curProd)
            this.$forceUpdate()
        },
        cancel: function () {
            Util.showConfirmationDialogSync(this.$modal, () => {
                this.curProd.productCombo = Util.deepCopy(this.curProd.productComboBkp)
                this.curProd.productGroups = Util.deepCopy(this.curProd.productGroupsBkp)
                this.curProd.productComboRaw = Util.deepCopy(this.curProd.productComboRawBkp)
                this.curProd.observations = Util.deepCopy(this.curProd.observationsBkp)
                this.curProd.mutexData = Util.deepCopy(this.mutexDataBkp)
                this.priceUpdate()
                this.finish(false)
            }, this.getString('cancelar_selecao'), () => {})
        },
        finish: function (addToCart = true) {
            if (addToCart) {
                if (this.editProduct) {
                    CartController.editProduct(this.curProd, this.editKey)
                } else {
                    CartController.addToCart(this.curProd)
                }
            }
            setTimeout(() => {
                let elements = document.querySelectorAll('.cart_item_container')
                if (elements && elements.length) {
                    let index = elements.length - 1
                    let element = elements[index]
                    if (element) {
                        element.scrollIntoView({'behavior': 'smooth', 'block': 'start'})
                    }
                }
            }, 800)
            this.$emit('closeProductItem')
            // eventModule.$emit('updateCart')
            eventModule.$emit('updateButtonCart', true)
            this.$forceUpdate()
        },
        addToCart: function () {
            this.itensLeft = this.curProd.productGroups.length
            this.hasToPickOptions = false
            this.curProd.productCombo = []
            this.curProd.productComboRaw = this.curProd.productComboRaw || []
            if (!this.itensLeft || this.itensLeft === 0) {
                CartController.setProductSequence(this.curProd, null, 0, 0)
            }
            // this.curProd.productComboRaw.forEach(c => {
            //     if (c != null) this.curProd.productCombo = this.curProd.productCombo.concat(c)
            // })
            const filteredProductComboRaw = this.curProd.productComboRaw.filter(c => c != null).map(c => c)
            this.curProd.productCombo = [...this.curProd.productCombo, ...filteredProductComboRaw].flat(1)

            let escholhaCorrente = this.curProd.productComboRaw
            let comboCorrente = this.curProd.productGroups
            let carrinhoPronto = true
            let mutexData = this.mutexData
            let self = this

            comboCorrente.reverse().forEach(function (product, i) {
                let isMutex = product.productGroupMutex && mutexData[product.productGroupMutex] != null
                let hasSelectedMutex = mutexData[product.productGroupMutex] && mutexData[product.productGroupMutex].selectedMutexCode != null
                let isSelectedMutex = isMutex && mutexData[product.productGroupMutex].selectedMutexCode === product.productGroupCode

                if (product.productGroupMin > 0 && !escholhaCorrente[comboCorrente.length - (i + 1)] && (!isMutex || !hasSelectedMutex || isSelectedMutex)) {
                    carrinhoPronto = false
                    let errorMessage = self.getString('voce_precisa_selecionar_algum') + product.productGroupName
                    Util.showErrorNotification({ title: errorMessage, text: null })
                } else if (escholhaCorrente[comboCorrente.length - (i + 1)] && (!isMutex || !hasSelectedMutex || isSelectedMutex)) {
                    let totalGroupSelected = 0
                    escholhaCorrente[comboCorrente.length - (i + 1)].forEach(product => {
                        totalGroupSelected += product.quantity ? product.quantity : 1
                    })
                    if (totalGroupSelected < product.productGroupMin) {
                        carrinhoPronto = false
                        let errorMessage = self.getString('voce_precisa_selecionar_algum') + product.productGroupName
                        Util.showErrorNotification({ title: errorMessage, text: null })
                    }
                }
            })
            comboCorrente.reverse()
            if (carrinhoPronto) {
                this.curProd.mutexData = this.mutexData

                if (this.exibeObsDigitada) {
                    this.curProd.typedObs = this.typedObs.trim()
                }
                this.wait = true
                PromotionalCampaignsController.updatePricesPromotionalCampaigns(this.curProd).then(() => {
                    this.wait = false
                    this.priceUpdate()
                    this.finish()
                })
                // this.priceUpdate()
                // this.finish()
            }
        },
        decreaseQtty: function (key = null) {
            if (key) {
                CartController.decreaseQtty(key, this)
            } else if (this.curProd.quantity > 1) {
                this.curProd.quantity -= 1
            }
            this.updateComboPrice()
        },
        increaseQtty: function (key = null) {
            if (key) {
                CartController.increaseQtty(key)
            } else {
                this.curProd.quantity += 1
            }
            this.updateComboPrice()
            // this.$forceUpdate()
        },
        decreaseObservationQtty: function (key, key2) {
            if (this.curProd.observationsChoice[key].observations[key2].quantity > 0) {
                let obsIndex = this.curProd.observations.findIndex(obs => {
                    return obs.obsCode === this.curProd.observationsChoice[key].observations[key2].obsCode &&
                        obs.obsGroupCode === this.curProd.observationsChoice[key].observations[key2].obsGroupCode &&
                        obs.obsName === this.curProd.observationsChoice[key].observations[key2].obsName &&
                        obs.price === this.curProd.observationsChoice[key].observations[key2].price &&
                        obs.quantity === this.curProd.observationsChoice[key].observations[key2].quantity
                })

                this.curProd.observations[obsIndex].quantity -= 1
                this.curProd.observationsChoice[key].observations[key2].quantity -= 1
                if (this.curProd.observations[obsIndex].quantity === 0) {
                    this.curProd.observations.splice(obsIndex, 1)
                }

                this.priceUpdate()
                this.$forceUpdate()
            }
        },
        increaseObservationQtty: function (key, key2) {
            if (this.curProd.observationsChoice[key].observations[key2].quantity === 0) {
                this.curProd.observationsChoice[key].observations[key2].quantity += 1
                let observationCopy = Util.deepCopy(this.curProd.observationsChoice[key].observations[key2])
                this.curProd.observations.push(observationCopy)
            } else {
                let obsIndex = this.curProd.observations.findIndex(obs => {
                    return obs.obsCode === this.curProd.observationsChoice[key].observations[key2].obsCode &&
                        obs.obsGroupCode === this.curProd.observationsChoice[key].observations[key2].obsGroupCode &&
                        obs.obsName === this.curProd.observationsChoice[key].observations[key2].obsName &&
                        obs.price === this.curProd.observationsChoice[key].observations[key2].price &&
                        obs.quantity === this.curProd.observationsChoice[key].observations[key2].quantity
                })
                this.curProd.observations[obsIndex].quantity += 1
                this.curProd.observationsChoice[key].observations[key2].quantity += 1
            }

            this.priceUpdate()
            this.$forceUpdate()
        },
        comboOption: function (comboItemChoices) {
            this.curProd.productComboRaw = this.curProd.productComboRaw || []
            CartController.setProductSequence(this.curProd, null, 0, 0)
            // Cada item filho precisa levar a referência de imprime sim/não do grupo ao qual pertence
            let groupPrint = this.curProd.productGroups[comboItemChoices.key].productGroupPrint
            comboItemChoices.option.forEach(item => {
                item.groupPrint = groupPrint
            })
            this.curProd.productComboRaw[comboItemChoices.key] = comboItemChoices.option

            // Trata as informações de grupos Mutex, se for o caso
            let mutexCode = this.curProd.productGroups[comboItemChoices.key].productGroupMutex
            let isMutexGroup = mutexCode && this.mutexData[mutexCode]

            if (isMutexGroup) {
                let newMutexData = Util.deepCopy(this.mutexData)

                if (comboItemChoices.option.length > 0) {
                    newMutexData[mutexCode].selectedMutexCode = this.curProd.productGroups[comboItemChoices.key].productGroupCode
                } else {
                    newMutexData[mutexCode].selectedMutexCode = null
                }

                this.mutexData = newMutexData
            }

            let groupKey = comboItemChoices.key
            let groupMaxItems = this.curProd.productGroups[groupKey].productGroupMax
            let groupSelectedItems = 0
            comboItemChoices.option.forEach(prod => {
                groupSelectedItems += prod.quantity || 1
            })
            this.curProd.productGroups[comboItemChoices.key].isVisible = true
            this.updateComboPrice()
            this.updateNextButton()
            if ((groupSelectedItems === groupMaxItems) && this.enableJumpGroup && this.enabledNextButton && !this.showAddToCartButton()) {
                this.nextWizardStep()
            }
            // this.updateComboPrice()
            this.$forceUpdate()
        },
        showAddToCartButton: function () {
            return this.showingLastWizardStep() || this.isSimpleProduct()
        },
        showingLastWizardStep: function () {
            let isTheLastGroup = this.curProd.productGroups && this.curProd.productGroups.length === this.wizardStepInEvidence + 1
            return isTheLastGroup || !this.hasGroupAfterCurrentMutex()
        },
        hasGroupAfterCurrentMutex: function () {
            let thisGroup = this.curProd.productGroups[this.wizardStepInEvidence]
            let isMutex = thisGroup && thisGroup.productGroupMutex && this.mutexData[thisGroup.productGroupMutex] != null

            if (isMutex) {
                let groups = this.curProd.productGroups || []
                let hasGroupAfter = false

                for (let i = this.wizardStepInEvidence + 1; i < groups.length; i++) {
                    let group = groups[i]
                    if (group.productGroupMutex !== thisGroup.productGroupMutex) {
                        hasGroupAfter = true
                        break
                    }
                }

                return hasGroupAfter
            } else {
                return true
            }
        },
        showCancelButton: function () {
            return this.wizardStepInEvidence === 0 || !this.hasGroupBeforeCurrentMutex()
        },
        hasGroupBeforeCurrentMutex: function () {
            let thisGroup = this.curProd.productGroups[this.wizardStepInEvidence]
            let isMutex = thisGroup && thisGroup.productGroupMutex && this.mutexData[thisGroup.productGroupMutex] != null

            if (isMutex) {
                let groups = this.curProd.productGroups || []
                let hasGroupBefore = false

                for (let i = this.wizardStepInEvidence - 1; i >= 0; i--) {
                    let group = groups[i]
                    if (group.productGroupMutex !== thisGroup.productGroupMutex) {
                        hasGroupBefore = true
                        break
                    }
                }

                return hasGroupBefore
            } else {
                return true
            }
        },
        updateNextButton: function () {
            if (this.curProd.productComboRaw != null || this.firstGroupIsOptional()) {
                this.checkNextButton()
            }
        },
        firstGroupIsOptional: function () {
            try {
                return this.curProd.productGroups[0].productGroupMin === 0
            } catch (error) {
                return false
            }
        },
        checkNextButton: function () {
            let currentGroup = this.curProd.productGroups[this.wizardStepInEvidence]
            let minForCurrentGroup = currentGroup.productGroupMin
            let groupPickedProds = (this.curProd.productComboRaw && this.curProd.productComboRaw[this.wizardStepInEvidence])
                ? this.curProd.productComboRaw[this.wizardStepInEvidence] : []
            let pickedFromCurrentGroup = 0

            groupPickedProds.forEach(prod => {
                pickedFromCurrentGroup += prod.quantity || 1
            })

            if (pickedFromCurrentGroup >= minForCurrentGroup) {
                this.enableNextButton()
            } else {
                this.disableNextButton()
            }
        },
        enableNextButton: function () {
            this.enabledNextButton = true
            this.$forceUpdate()
        },
        disableNextButton: function () {
            this.preventShaking = false
            this.enabledNextButton = false
        },
        previousWizardStep: function () {
            this.goingForward = false
            let previousGroup = this.curProd.productGroups[this.wizardStepInEvidence - 1]
            let previousGroupIsMutex = previousGroup.productGroupMutex && this.mutexData[previousGroup.productGroupMutex] != null

            if (previousGroupIsMutex) {
                let mutexKey = previousGroup.productGroupMutex
                let pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex

                if (this.wizardStepInEvidence !== pickedGroupIndex) {
                    this.alternativeLayoutCounter--
                    this.wizardStepInEvidence = pickedGroupIndex
                    this.curProd.productGroups[this.wizardStepInEvidence].isVisible = true
                    setTimeout(() => {
                        let element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
                        document.getElementById(`curProd-${this.wizardStepInEvidence}`).scrollIntoView({'behavior': 'smooth', 'block': 'start'})
                        if (element) element.scrollIntoView({'behavior': 'smooth', 'block': 'start'})
                    }, 600)
                } else {
                    this.goToPreviousNotMutex(mutexKey)
                }
            } else {
                this.alternativeLayoutCounter--
                this.wizardStepInEvidence--
                this.curProd.productGroups[this.wizardStepInEvidence].isVisible = true
                setTimeout(() => {
                    let element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
                    if (element) element.scrollIntoView({'behavior': 'smooth', 'block': 'start'})
                }, 600)
            }

            this.preventShaking = true
            this.checkNextButton()
        },
        nextWizardStep: function (calledOnMounted = false) {
            this.goingForward = true
            if (this.enabledNextButton || calledOnMounted) {
                let nextGroup = this.curProd.productGroups[this.wizardStepInEvidence + 1]
                let nextGroupIsMutex = nextGroup.productGroupMutex && this.mutexData[nextGroup.productGroupMutex] != null
                if (nextGroupIsMutex) {
                    let mutexKey = nextGroup.productGroupMutex
                    let alreadyPickedMutexGroup = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex != null

                    if (alreadyPickedMutexGroup) {
                        let pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex

                        if (this.wizardStepInEvidence !== pickedGroupIndex) {
                            if (!calledOnMounted) this.alternativeLayoutCounter++
                            this.wizardStepInEvidence = pickedGroupIndex
                            setTimeout(() => {
                                let element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
                                if (element) element.scrollIntoView({'behavior': 'smooth', 'block': 'start'})
                            }, 600)
                        } else if (!calledOnMounted) {
                            this.goToNextNotMutex(mutexKey)
                        }
                    } else {
                        setTimeout(() => { this.openSelectMutexModal(mutexKey) }, 200)
                    }
                } else {
                    this.alternativeLayoutCounter++
                    this.wizardStepInEvidence++
                    setTimeout(() => {
                        let element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
                        if (element) element.scrollIntoView({'behavior': 'smooth', 'block': 'start'})
                    }, 500)
                }
                setTimeout(() => {
                    eventModule.$emit('checkNextPreselect', this.wizardStepInEvidence)
                    this.checkNextButton()
                }, 100)
            }
        },
        goToNextNotMutex: function (mutexKey) {
            let groups = this.curProd.productGroups || []

            for (let i = this.wizardStepInEvidence; i < groups.length; i++) {
                let currentGroup = groups[i]
                if (currentGroup.productGroupMutex !== mutexKey) {
                    this.alternativeLayoutCounter++
                    this.wizardStepInEvidence = i
                    break
                }
                this.curProd.productGroups[this.wizardStepInEvidence].isVisible = true
            }
            setTimeout(() => {
                let element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
                if (element) element.scrollIntoView({'behavior': 'smooth', 'block': 'start'})
            }, 600)
        },
        goToPreviousNotMutex: function (mutexKey) {
            let groups = this.curProd.productGroups || []

            for (let i = this.wizardStepInEvidence; i >= 0; i--) {
                let currentGroup = groups[i]
                if (currentGroup.productGroupMutex !== mutexKey) {
                    this.alternativeLayoutCounter--
                    this.wizardStepInEvidence = i
                    break
                }
                this.curProd.productGroups[this.wizardStepInEvidence].isVisible = true
            }
            setTimeout(() => {
                let element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
                if (element) element.scrollIntoView({'behavior': 'smooth', 'block': 'start'})
            }, 600)
        },
        handleFirstGroupMutexCase: function () {
            let firstGroup = this.curProd.productGroups[0]
            let firstGroupIsMutex = firstGroup.productGroupMutex && this.mutexData[firstGroup.productGroupMutex] != null

            if (firstGroupIsMutex) {
                let mutexKey = firstGroup.productGroupMutex
                let calledOnMounted = true
                this.openSelectMutexModal(mutexKey, calledOnMounted)
            }
        },
        openSelectMutexModal: function (mutexKey, calledOnMounted = false, oldProductGroupCode) {
            this.oldProductGroup = oldProductGroupCode
            this.buildGroupsData(mutexKey)
            this.calledOnMounted = calledOnMounted
            this.showSelectMutexModal = true
        },
        closeSelectMutexModal: function () {
            this.showSelectMutexModal = false
        },
        pickMutexGroup: function (selectedGroupIndex, mutexKey, calledOnMounted, oldProductGroupIndex) {
            let firstTimePicked = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex == null
            this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex = selectedGroupIndex
            if (firstTimePicked) {
                this.nextWizardStep(calledOnMounted)
            } else {
                this.changePickedMutex(mutexKey, oldProductGroupIndex)
            }
        },
        changePickedMutex: function (mutexKey, oldProductGroupIndex) {
            let pickedGroupIndex = this.mutexData[mutexKey].alternativeLayoutPickedGroupIndex
            if (oldProductGroupIndex && (pickedGroupIndex !== oldProductGroupIndex)) {
                this.clearCurrentMutexChoices(oldProductGroupIndex)
                this.curProd.productGroups[oldProductGroupIndex].isVisible = false
                setTimeout(() => {
                    this.wizardStepInEvidence = pickedGroupIndex
                    this.checkNextButton()
                    let element = document.getElementById(`curProd-${this.wizardStepInEvidence}`)
                    if (element) element.scrollIntoView({'behavior': 'smooth', 'block': 'start'})
                }, 600)
            }
        },
        clearCurrentMutexChoices: function (oldProductGroupIndex) {
            eventModule.$emit('deleteAllChoices', oldProductGroupIndex)
        },
        buildGroupsData: function (mutexKey) {
            this.groupsData = []
            let groups = this.curProd.productGroups || []

            groups.forEach((group, idx) => {
                let isSameMutex = group.productGroupMutex === mutexKey
                if (isSameMutex) {
                    this.groupsData.push({
                        name: group.productGroupName,
                        index: idx,
                        mutexKey: mutexKey
                    })
                }
            })
        },
        jumpGroup: function (groupKey, isMutexGroup, mutexCode) {
            /* if (isMutexGroup) {
                let nextGroups = (this.curProd.productGroups || []).slice(groupKey + 1)
                let nextNotMutexIndex = nextGroups.findIndex(element => element.productGroupMutex !== mutexCode)
                if (nextNotMutexIndex !== -1) {
                    let groupsToJump = groupKey + 1 + nextNotMutexIndex
                    location.hash = '#' + groupsToJump
                    eventModule.$emit('checkNextPreselect', groupsToJump)
                }
            } else {
                let nextGroupHash = groupKey + 1
                let jumpToNextPreselect = this.jumpToNextPreselect(nextGroupHash)
                if (jumpToNextPreselect) nextGroupHash++
                location.hash = '#' + nextGroupHash
                eventModule.$emit('checkNextPreselect', nextGroupHash)
            } */
            // this.nextWizardStep(true)
        },
        jumpToNextPreselect: function (nextGroupHash) {
            try {
                let isOptionalGroup = false
                let isFollowedByPreselec = false
                if (this.curProd.productGroups && this.curProd.productGroups[nextGroupHash] && this.curProd.productGroups[nextGroupHash].productGroupMin === 0) {
                    isOptionalGroup = true
                }
                if (this.curProd.productGroups && this.curProd.productGroups[nextGroupHash + 1] &&
                    this.curProd.productGroups[nextGroupHash + 1].productGroupMax === 1 &&
                    this.curProd.productGroups[nextGroupHash + 1].productGroupItems
                ) {
                    let hasAnyPreselec = this.curProd.productGroups[nextGroupHash + 1].productGroupItems.filter(element => element.subItemPreSelected === 'S')
                    if (hasAnyPreselec) {
                        isFollowedByPreselec = true
                    }
                }
                return isOptionalGroup && isFollowedByPreselec
            } catch (error) {
                return false
            }
        },
        isSimpleProduct: function () {
            return (this.curProd.productGroups || []).length === 0
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        updateComboPrice: function () {
            let product = Util.deepCopy(this.curProd)
            product.productCombo = []
            product.productComboRaw = product.productComboRaw || []
            if (product.productComboRaw && product.productComboRaw.length > 0) {
                const filteredProductComboRaw = product.productComboRaw.filter(c => c != null).map(c => c)
                if (filteredProductComboRaw) {
                    product.productCombo = [...product.productCombo, ...filteredProductComboRaw].flat(1)
                }
            }
            product.mutexData = this.mutexData
            if (this.exibeObsDigitada) {
                product.typedObs = this.typedObs.trim()
            }
            ProductController.priceUpdate(product)
            this.totalPrice = product.totalItemPrice * product.quantity
            this.$forceUpdate()
        },
        getPrice: function () {
            this.totalPrice = this.formatMoney(this.totalPrice)
        },
        editObs: function () {
            this.inputElement = this.$refs.typedObsDiv
            this.editingObs = true

            let container = document.getElementById('page-container')
            setTimeout(() => {
                container.scrollTo(0, container.scrollHeight)
            }, 100)
        },
        closeKeyboard: function () {
            this.editingObs = false
            this.typedObs = this.$refs.typedObsDiv.innerText
        },
        closeProductItem: function () {
            this.curProd = null
            this.seletctedProduct = null
            this.$emit('closeProductItem')
            eventModule.$emit('updateButtonCart', true)
        },
        cutText: function (text) {
            if (text.length > 100 && !this.showText) {
                return text.substring(100, 0) + this.getString('veja_mais')
            }
            return text
        },
        removeBlockedProdsObs: function (obs) {
            return Util.removeBlockedProdsObs(obs)
        },
        getMessageObservationsMinQuantity: function (minQuantity) {
            return this.getString('escolha_pelo_menos') + ' ' + minQuantity + ' ' + (minQuantity > 1 ? this.getString('observacoes') : this.getString('observacao')) + ' *'
        },
        checkMinObs: function () {
            let minObsGroup = true
            this.curProd.observationsChoice.forEach(obsGroup => {
                if (obsGroup.minQuantity && obsGroup.minQuantity > 0) {
                    minObsGroup = false
                }
            })
            this.minObs = minObsGroup
            return minObsGroup
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import (reference) url("../assets/common.less");

.page-container{
    position: relative;
    display: block;
    overflow: auto;
    overflow-x: hidden;
    margin: 10px 20px 10px 15px;
    padding: 15px 5px 130px 5px;
    .prod-item-header-container {
        margin: 10px;
        .header {
            display: flex;
            flex-direction: row;
            align-items: center;
            h3 {
                margin: auto;
                padding: 0;
                padding-left: 10px;
            }
        }
    }
}

.prod-item-page {
    background: white;
    font-size: 30px;
    .image-container {
        padding: 20px 0;
        margin: 35px 0;
        img {
            // width: auto;
            height: 100%;
            // max-width: -webkit-fill-available;
            width: 100%;
            max-height: 500px;
            object-fit: contain;
            margin: auto;
            display: block;
            border-radius: 5px;
        }
    }
    .details-container {
        display: flex;
        align-content: center;
        align-items: center;
        font-size: 27px;
        p {
            padding: 0;
        }
    }
    .data-container {
        display: grid;
        grid-template-columns: auto;
        padding: 0 0 30 0;
        top: 0;
        margin-bottom: 0;
        padding-bottom: 0;
        position: relative;
        .price-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0;
            margin: 0;
            .price {
                font-size: 35px;
            }
        }
    }
    .observations-container {
        padding: 0 10px 50px 10px;
        .grupo-op-name {
            display: flex;
            color: black;
            margin-bottom: 15px;
            justify-content: space-between;
            span {
                display: inline-block;
                vertical-align: middle;
                font-weight: bold;
                font-size: 35px;
            }
        }
        .min-observations-message {
            // text-align: center;
            font-size: 23px;
            margin-bottom: 15px;
            &.red-text {
                color: red;
            }
        }
        .typed-obs-text {
            font-size: 32px;
            font-family: @default-font;
            width: 100%;
            resize: none;
            border: solid 2px rgba(0, 0, 0, 0.3);
        }
        .div-input-android {
            position: relative;
            display: block;
            font-size: 32px;
            height: 180px;
            background-color: white;
            color: black;
            border: solid 2px rgba(0, 0, 0, 0.3);
            padding: 20px;
            border-radius: 10px;
        }
        .obs-item-container {
            position: relative;
            display: grid;
            grid-template-columns: calc(50% - 5px) calc(50% - 5px);
            grid-column-gap: 15px;
            .item-obs {
                display: grid;
                margin-top: 15px;
                grid-column-gap: 5px;
                grid-template-columns: 13% calc(90% - 5px);
                border: solid 2px rgba(0, 0, 0, 0.3);
                border-radius: 10px;
                padding: 10px 15px;
                &.quantity-control {
                    grid-template-columns: 40% calc(60% - 15px);
                }
                label {
                    font-size: 23px;
                }
        }
    }

    #keyboard-filler {
        height: 210px;
    }
}
    .prod-item-footer {
        position: fixed;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        background: rgba(126, 126, 126, 0.2);
        height: 131px;
        padding: 0 20px;
        bottom: 60px;
        left: calc(1.1 / (1.1 + 1.3 + 1) * 100vw);
        width: calc((1.2 + 1) / (1.1 + 1.3 + 1) * 100vw);
        animation: upper-in 0.4s;
        button {
            display: block;
            margin: auto;
            box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
            min-width: 45%;
            height: 100px;
        }
    }
}

#keyboard {
    .keyboard;
    position: fixed;
    bottom: 0;
}

#android-keyboard {
    .keyboard;
    bottom: 60px;
    margin: auto;
}

.keyboard-overlay {
    z-index: 10;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
}

.shake-button {
    animation: shakeShake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97);
    animation-iteration-count: 1;
}

@keyframes shakeShake {
  0% { transform: rotateZ(4deg); }
  20% { transform: rotateZ(-4deg); }
  40% { transform: rotateZ(4deg); }
  60% { transform: rotateZ(-4deg); }
  80% { transform: rotateZ(4deg); }
  100% { transform: rotateZ(0deg); }
}

.slide-right-enter-active {
    transition: all .4s ease-in-out;
    // transition-delay: .3s;
}
.slide-right-leave-active{
    transition: all .3s ease-in-out;
}
.slide-right-enter {
    transform: translateX(100vw);
}
.slide-right-leave-to {
    // transform: translate(-500px);
    opacity: 0;
}

@media (min-width: 699px) and (max-width: 1025px) { //@tablet
    .page-container{
        height: auto;
        margin: 10px 10px;
        margin-right: 0;
        padding: 15px 0 80px 0;
        overflow: hidden;
        overflow-x: hidden;
    }

    .prod-item-page {
        font-size: 22px;

        .prod-item-header-container.alternative-layout{
            padding: 0 15px;
        }

        .image-container {
            padding: 10px 0;
            margin: 25px 0;
            img {
                width: 100%;
                height: 100%;
                max-height: 350px;
            }
        }
        .details-container {
            p {
                font-size: 19px;
            }
        }
        .data-container {
            .price-container {
                padding: 10px 0;
                .price {
                    font-size: 24px;
                    margin-bottom: 0;
                }
            }
        }
        .observations-container {
            padding: 0 15px 50px 15px;
            width: calc(100% - 30px);
            .grupo-op-name {
                margin-bottom: 15px;
                span {
                    font-weight: bold;
                    font-size: 23px;
                }
            }
            .min-observations-message {
                font-size: 19px;
            }
            .typed-obs-text {
                font-size: 26px;
                width: 99%;
            }
            .obs-item-container{
                grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
                grid-column-gap: 15px;
                .item-obs {
                    margin-top: 20px;
                    grid-column-gap: 0;
                    grid-template-columns: 15% calc(85% - 15px);
                    &.quantity-control {
                        grid-template-columns: 40% calc(60% - 15px);
                    }
                    .container-input {
                        padding-left: 0;
                        margin-right: 15px
                    }
                    label {
                        text-align: center;
                        font-size: 17px;
                    }
                }
            }
        }

        #keyboard-filler {
            height: 150px;
        }
        &.slimMode{
            .page-container{
                height: calc(100vh - 190px);
            }
        }
        .prod-item-footer {
            grid-template-columns: auto auto;
            height: 100px;
            padding: 0;
            left: calc(1.1 / (1.1 + 1.2 + 1) * 100vw);
            width: calc((1.2 + 1) / (1.1 + 1.2 + 1) * 100vw);
            button {
                min-width: 220px;
                height: 70px;
                margin: 10px;
            }
            bottom: 55px;
        }
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
        max-width: 760px;
        font-size: 20px;
    }
}

@media (max-width: 698px) { // Gertec SK210
    .page-container {
        margin: 5px 5px;
        padding: 10px 5px 110px 5px;
    }
    .prod-item-page {
        font-size: 18px;

        .prod-item-header-container{
            padding: 0;
            margin: 5px;
            .header {
                display: flex;
                flex-direction: row;
                align-items: center;
                h3 {
                    margin: auto;
                    padding: 0;
                }
            }
        }

        .image-container {
            padding: 10px 0;
            margin: 10px 0;
            img {
                width: 100%;
                height: 100%;
                max-height: 220px;
            }
        }
        .details-container {
            p {
                font-size: 15px;
            }
        }
        .data-container {
            .price-container {
                padding: 10px 0;
                .price {
                    font-size: 22px;
                    margin-bottom: 0;
                }
            }
        }
        .observations-container {
            padding: 10px 3px;
            width: calc(100% - 10px);
            .grupo-op-name {
                margin-bottom: 5px;
                span {
                    font-weight: bold;
                    font-size: 18px;
                }
            }
            .min-observations-message {
                font-size: 15px;
            }
            .typed-obs-text {
                font-size: 18px;
                width: 99%;
            }
            .obs-item-container{
                grid-template-columns: calc(50% - 2.5px) calc(50% - 2.5px);
                grid-column-gap: 5px;
                .item-obs {
                    margin-top: 15px;
                    grid-column-gap: 0;
                    grid-template-columns: 8% auto;
                    border-radius: 5px;
                    &.quantity-control {
                        grid-template-columns: 40% calc(60% - 10px);
                    }
                    .container-input {
                        padding-left: 0;
                        margin-right: 5px
                    }
                    label {
                        // text-align: center;
                        padding-left: 8px;
                        font-size: 13px;
                    }
                }
            }
            .div-input-android {
                font-size: 18px;
                height: 120px;
                border: solid 2px rgba(0, 0, 0, 0.3);
                padding: 10px;
                border-radius: 5px;
            }
        }

        #keyboard-filler {
            height: 150px;
        }
        &.slimMode{
            .page-container{
                height: calc(100vh - 190px);
            }
        }
        .prod-item-footer {
            grid-template-columns: auto auto !important;
            height: 70px !important;
            padding: 0 5px;
            bottom: 30px;
            left: calc(1 / (1 + 1.1 + 1) * 100vw) !important;
            width: calc((1.2 + 1) / (1 + 1.4 + 1) * 100vw) !important;
            button {
                min-width: 140px !important;
                height: 55px !important;
                margin: 5px !important;
            }
        }
    }
    #android-keyboard {
        .small-screen-keyboard;
        bottom: 30px;
    }
}

@media (orientation: landscape) {
    .prod-item-page.prod-item-page {
        font-size: 22px;

        .page-container {
            padding: 0;
            margin: 0 10px;
            .prod-item-header-container{
                padding: 0 15px;
                display: grid;
                grid-template-columns: auto;
                grid-template-areas:
                    "header header"
                    "image image"
                    "details details";
                gap: 10px;
                &.has-data-container {
                    grid-template-columns: 1.5fr 1fr;
                    grid-template-areas:
                        "header header"
                        "image data"
                        "details details";
                    gap: 10px;
                }
            .header {
                grid-area: header;
                color: @primary-dark;
                .btn-big {
                    width: 50px;
                    height: 50px;
                }
            }

            .image-container {
                grid-area: image;
                padding: 0 0;
                margin: 0;
                border-right: solid 1px rgba(0, 0, 0, 0.3);
                img {
                    width: 100%;
                    height: 100%;
                    max-height: 210px;
                    object-fit: contain;
                }
            }

            .data-container {
                grid-area: data;
                .price-container {
                    padding: 10px 0;
                    display: flex;
                    flex-direction: column-reverse;
                    justify-content: space-evenly;
                    .price {
                        font-size: 24px;
                        margin-bottom: 0;
                    }
                }
            }

            .details-container {
                grid-area: details;
                p {
                    font-size: 19px;
                }
            }
            }
        }

        .observations-container {
            padding: 0 15px 50px 15px;
            width: calc(100% - 30px);
            .grupo-op-name {
                margin-bottom: 15px;
                span {
                    font-weight: bold;
                    font-size: 23px;
                }
            }
            .min-observations-message {
                font-size: 19px;
            }
            .typed-obs-text {
                font-size: 26px;
                width: 99%;
            }
            .obs-item-container{
                grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
                grid-column-gap: 15px;
                .item-obs {
                    margin-top: 20px;
                    grid-column-gap: 0;
                    grid-template-columns: 15% calc(85% - 15px);
                    &.quantity-control {
                        grid-template-columns: 40% calc(60% - 15px);
                    }
                    .container-input {
                        padding-left: 0;
                        margin-right: 15px
                    }
                    label {
                        text-align: center;
                        font-size: 17px;
                    }
                }
            }
        }

        &.slimMode{
            .page-container{
                height: calc(100vh - 190px);
            }
        }

        .prod-item-footer {
            bottom: 30px;
            height: 80px;
            left: calc(1 / (1 + 3 + 1) * 100vw);
            width: calc((3 + 1) / (1 + 3 + 1) * 100vw);
            button {
                min-width: 40%;
                height: 70px;
                margin: 10px;
            }
        }
    }

    #keyboard-filler {
        height: 150px;
    }
}

@keyframes upper-in {
    0% {
        transform: translateY(130px);
    }
    100% {
        transform: translateY(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductItemGom.vue